import React from "react";
import { MdVideocamOff } from "react-icons/md";

const InitCameraOffBox = () => {
  return (
    <div
      style={{
        /* flex:1 fills the remaining height in the flex-column container.
           width:100% fills horizontally. No position:absolute needed. */
        flex: "1 1 auto",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "12px",
        background: "#0c1428",
        fontFamily: "'Inter', system-ui, sans-serif",
      }}
    >
      {/* Teal icon ring */}
      <div
        style={{
          width: "60px",
          height: "60px",
          borderRadius: "50%",
          background: "rgba(34, 211, 238, 0.07)",
          border: "1.5px solid rgba(34, 211, 238, 0.20)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#22d3ee",
          fontSize: "26px",
          flexShrink: 0,
        }}
      >
        <MdVideocamOff />
      </div>

      {/* Label */}
      <span
        style={{
          fontSize: "13.5px",
          fontWeight: "500",
          color: "#8b9dc3",
          letterSpacing: "0.01em",
        }}
      >
        Camera is off
      </span>
    </div>
  );
};

export default InitCameraOffBox;